// extracted by mini-css-extract-plugin
export default {"puppy":"BodyDogPuppy_puppy__ldAmX","caption":"BodyDogPuppy_caption__DTdHi"};